/**
 * Project panel
 *
 * Created by stefensuhat on 08/08/18 2.52 PM
 */

import { api } from 'utils';

const defaultState = { items: [], item: {}, errors: null };

const model = {
    name: 'payment',
    state: defaultState,
    reducers: {
        reset: (state) => ({ ...state, ...defaultState }),
        fetchResponse: (state, payload) => ({ ...state, items: payload.data }),
        findResponse: (state, payload) => ({ ...state, item: payload }),
    },
    effects: {
        async fetch() {
            await api.get('payment_methods')
                .then((response) => this.fetchResponse(response));
        },
        async find(params) {
            await api.get(`payment_methods/${params}`)
                .then((response) => this.findResponse(response));
        },
    },
};

export default model;
